// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toast-alert {
  border: 0 !important;
  border-top: var(--spacing-extra-small) solid var(--color-yellow) !important;
  border-radius: var(--spacing-extra-small);
  box-shadow: 1px 5px 24px -14px #59585a;
  cursor: auto;
}
.toast-alert .anticon svg {
  fill: var(--color-yellow);
}
.toast-alert.ant-alert-type-error {
  border-top: var(--spacing-extra-small) solid var(--color-error) !important;
}
.toast-alert.ant-alert-type-error .anticon svg {
  fill: var(--color-error);
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/ToastAlert/ToastAlertStyles.less"],"names":[],"mappings":"AACA;EACI,oBAAA;EACA,2EAAA;EACA,yCAAA;EAEA,sCAAA;EACA,YAAA;AADJ;AALA;EAUY,yBAAA;AAFZ;AAKI;EACI,0EAAA;AAHR;AAEI;EAIY,wBAAA;AAHhB","sourcesContent":["// DESKTOP\n.toast-alert {\n    border: 0 !important;\n    border-top: var(--spacing-extra-small) solid var(--color-yellow) !important;\n    border-radius: var(--spacing-extra-small);\n\n    box-shadow: 1px 5px 24px -14px rgba(89,88,90,1);\n    cursor: auto;\n\n    .anticon {\n        svg {\n            fill: var(--color-yellow);\n        }\n    }\n    &.ant-alert-type-error {\n        border-top: var(--spacing-extra-small) solid var(--color-error) !important;\n        .anticon {\n            svg {\n                fill: var(--color-error);\n            }\n        }\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
